export default {
    computed: {
        // ------------------------------------------------
        // ------ [COMPUTED] Style
        // [COMPUTED] Style, TD Cell style -> SIZE & Positioning
        tdStyle() {
            // 1. Prepare variable
            // No op
            
            // 2. Build Style
            // 2.1 Custom Style
            let style = Object.assign({},this.field.customStyle);
            // 2.2 isHide?
            if(this.field.hide) {
                style.flex = "0 0 0px";
                style['min-width'] = '1px';
                style['opacity'] = '0';
            }
            // 2.3 Cell size
            else if(this.field.__width) {
                // 2.3.1 Has width
                var w = this.field.__width, x;
                if(typeof w !== 'string' || w.slice(-1) !=='%') {
                    w = parseInt(w)+"px";
                }
                style.flex = '0 0 '+w;
                style['max-width'] = w;
                style['min-width'] = '0px'
            } else {
                // 2.3.2 No width -> Expanded width cell
                style.flex = "1 1 0px";
                style['min-width'] = this.gridInfo.opts.defaultFieldWidth+'px'
            }
            // 2.4 Set Height
            if(this.isMerged){
                // 2.4.1 Merged cell
                var height = this.rowInfo.groupHeight[this.field.__isGroup];
                if(height) {style['height'] = height+'px';}
            } else {
                // 2.4.x Normal cell
                style['height'] = this.gridInfo.opts.rowHeight+"px";
            }
            // x. return style
            return style;
        },
        // [COMPUTED] Style, Class of cell
        tdClass() {
            // 1. Prepare variable
            // No op
            
            // 2. Build Class
            var clazz = [];
            // 2.1 Custom Class
            if(this.field.__cuzClass) {clazz = clazz.concat(this.field.__cuzClass)}

            // customClass를 사용하기 위해 수정 (2022.04.29 aaron.sun)
            // if(this.field.__fnClass) {clazz.push(this.field.__fnClass(this.value, this.rowInfo.row))}
            if(this.field.__fnClass) {
                let _infoObj = this.makeInfoObj();
                clazz.push(this.field.__fnClass(this.value, _infoObj, this.gridInfo.caller))
            }

            // 2.2 Class by cell type
            switch(this.field.type) {
            case 'number' : clazz.push('ur-data-grid__content__cell--number' );break;
            case 'code'   : clazz.push('ur-data-grid__content__cell--code'   );break;
            case 'date'   : clazz.push('ur-data-grid__content__cell--date'   );break;
            case 'boolean': clazz.push('ur-data-grid__content__cell--boolean');break;
            default       : clazz.push('ur-data-grid__content__cell--default');break;
            }
            switch(this.field.align) {
            case 'left'  : clazz.push('ur-data-grid__content__cell--left'  );break;
            case 'right' : clazz.push('ur-data-grid__content__cell--right' );break;
            case 'center': clazz.push('ur-data-grid__content__cell--center');break;
            default: /* No op */
            }
            
            // 2.4 clickable
            if(this.isClick)    {clazz.push('ur-data-grid__content__cell--clickable')}
            // 2.5 Merged cell
            if(this.isMerged)   {clazz.push('ur-data-grid__content__cell--merged')}
            // 2.6 Hided cell
            if(this.isHide)     {clazz.push('ur-data-grid__content__cell--hided')}
            // 2.7 Cell mode
            if(this.gridInfo.opts.cellMode) {clazz.push('ur-data-grid__content__cell--cell-mode')}
            // 2.8 Editable
            if(this.isEditable) {clazz.push('ur-data-grid__content__cell--editable')}
            // x. Retury style
            return clazz;
        },
    },
    // customClass를 사용하기 위해 methods 추가 (2022.04.29 aaron.sun)
    methods :{
        makeInfoObj(){
            let infoObj = {};
            infoObj.field= {};
            infoObj.field.text = this.field.text;
            infoObj.field.type = this.field.type;
            infoObj.field.value = this.field.value;
            infoObj.row = this.rowInfo.row;
            return infoObj;
        }
   }
}